import { useDropzone } from "react-dropzone";
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { sets3FileKey, EventStatePayload } from '../../../../redux/eventSlice';
import { useDispatch } from 'react-redux';
import Spinner from '../../../../components/spinner';

type DropZonefileProps = {
  content: JSX.Element;
  eventObject?: EventStatePayload;
  eventId?: string;
};

const DropZonefile = ({ content, eventObject, eventId }: DropZonefileProps) => {
  const dispatch = useDispatch();
console.log(eventId)
  const [isUploading, setIsUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  useEffect(() => {
    if (eventObject?.s3FileKey) {
      const s3FileKey = eventObject.s3FileKey;
      dispatch(sets3FileKey(s3FileKey));
    }
  }, [eventObject]);

  const onDrop = async (acceptedFiles: File[]) => {
    const file = acceptedFiles[0];

    if (!eventId) {
      console.error("❌ Missing eventId for upload");
      return;
    }

    try {
      setIsUploading(true);

      // 1. Get signed URL from API
      const res = await axios.get(
        `https://8vjqrpkdei.execute-api.us-east-1.amazonaws.com/api/get-upload-url/${eventId}`
      );
      const signedUrl = res.data.url;
      const fileKey = res.data.fileKey;
      dispatch(sets3FileKey(fileKey));
      // 2. Upload file to S3 via signed URL
      await axios.put(signedUrl, file, {
        headers: {
          'Content-Type': 'application/pdf',
        },
      });

      setUploadSuccess(true);
    } catch (error) {
      console.error('Upload error:', error);
    } finally {
      setIsUploading(false);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div
      className="flex h-full !w-[700px] cursor-pointer items-center justify-center rounded-xl border-dashed border-navy-700"
      {...getRootProps({ className: "dropzone" })}
    >
      <input {...getInputProps()} />
      {isUploading ? <Spinner /> : <button className="h-full !w-full">{content}</button>}
    </div>
  );
};

export default DropZonefile;
